import DrawBase from "../DrawBase"
import EditGatheringPlace from "./EditGatheringPlace"
import { lonlats2cartesians } from "../../utils/CoordinateUtil"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
//3个点

const Place_T = 0.4;
const FITTING_COUNT = 100
const HALF_PI = Math.PI / 2
const ZERO_TOLERANCE = 0.000003
const TWO_PI = Math.PI * 2
const ERADIUS = 6378137; //赤道半径
const PRADIUS = 6356725; //极半径

class DrawGatheringPlace extends DrawBase {

    constructor(options) {
        super(options);
    }

    getEditInterface() {
        return EditGatheringPlace;
    }

    getTypeName() {
        return "集结地";
    }

    getType() {
        return "polygon_Nor";
    }

    checkLeftClick() {
        if (this.positionsTemp.length < 3) {
            return true;
        }
        return false;
    }

    checkMouseMove() {
        if (this.positionsTemp.length <= 1) {
            return false;
        }
        return true;
    }


    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positions = [];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            return new $this.Cesium.PolygonHierarchy($this.computeGatheringPlace(positions));

        }, false);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var positions = JSON.parse(data.editPositions);
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.computeGatheringPlace(positions));

        }, true);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polygon")
    }

    computeGatheringPlace(positions) {
        var pnts = this.cart2Wgs84(positions);
        var res = this.generate(pnts);
        return lonlats2cartesians(res);

    }

    //getThirdPoint,getBisectorNormals,getCubicValue
    //FITTING_COUNT t
    generate(pnts) {
        var that = this;
        var mid = undefined;
        if (that.distance(pnts[pnts.length-2], pnts[pnts.length-1]) < ZERO_TOLERANCE){
            pnts=[pnts[0],pnts[1]];
        }
        if (pnts.length == 2) {
            mid = that.mid(pnts[0], pnts[1]);
            var d = that.distance(pnts[0], mid) / 0.9;
            var pnt = that.getThirdPoint(pnts[0], mid, HALF_PI, d, true);//--
            pnts = [pnts[0], pnt, pnts[1]];
        }
        mid = that.mid(pnts[0], pnts[2]);
        pnts.push(mid, pnts[0], pnts[1]);

        var normals = [];
        for (var i = 0; i < pnts.length - 2; i++) {
            var pnt1 = pnts[i];
            var pnt2 = pnts[i + 1];
            var pnt3 = pnts[i + 2];
            var normalPoints = that.getBisectorNormals(Place_T, pnt1, pnt2, pnt3);////--
            normals = normals.concat(normalPoints);
        }
        var count = normals.length;
        normals = [normals[count - 1]].concat(normals.slice(0, count - 1));
        var pList = [];
        for (i = 0; i < pnts.length - 2; i++) {
            pnt1 = pnts[i];
            pnt2 = pnts[i + 1];
            pList.push(pnt1);
            for (var t = 0; t <= FITTING_COUNT; t++) {
                var pnt = that.getCubicValue(t / FITTING_COUNT, pnt1, normals[i * 2], normals[i * 2 + 1], pnt2);
                pList.push(pnt);
            }
            pList.push(pnt2);
        }

        return pList;
    }

    mid(point1, point2) {
        return [(point1[0] + point2[0]) / 2, (point1[1] + point2[1]) / 2]
    }

    distance(pnt1, pnt2) {
        return (Math.sqrt(Math.pow((pnt1[0] - pnt2[0]), 2) + Math.pow((pnt1[1] - pnt2[1]), 2)))
    }

    getNormal(pnt1, pnt2, pnt3) {
        let dX1 = pnt1[0] - pnt2[0]
        let dY1 = pnt1[1] - pnt2[1]
        let d1 = Math.sqrt(dX1 * dX1 + dY1 * dY1)
        dX1 /= d1
        dY1 /= d1
        let dX2 = pnt3[0] - pnt2[0]
        let dY2 = pnt3[1] - pnt2[1]
        let d2 = Math.sqrt(dX2 * dX2 + dY2 * dY2)
        dX2 /= d2
        dY2 /= d2
        let uX = dX1 + dX2
        let uY = dY1 + dY2
        return [uX, uY]
    }

    getAzimuth(startPoint, endPoint) {
        var that = this;
        let azimuth
        let angle = Math.asin(Math.abs(endPoint[1] - startPoint[1]) / (that.distance(startPoint, endPoint)))
        if (endPoint[1] >= startPoint[1] && endPoint[0] >= startPoint[0]) {
            azimuth = angle + Math.PI
        } else if (endPoint[1] >= startPoint[1] && endPoint[0] < startPoint[0]) {
            azimuth = Math.PI * 2 - angle
        } else if (endPoint[1] < startPoint[1] && endPoint[0] < startPoint[0]) {
            azimuth = angle
        } else if (endPoint[1] < startPoint[1] && endPoint[0] >= startPoint[0]) {
            azimuth = Math.PI - angle
        }
        return azimuth
    }


    getCubicValue(t, startPnt, cPnt1, cPnt2, endPnt) {
        t = Math.max(Math.min(t, 1), 0)
        let [tp, t2] = [(1 - t), (t * t)]
        let t3 = t2 * t
        let tp2 = tp * tp
        let tp3 = tp2 * tp
        let x = (tp3 * startPnt[0]) + (3 * tp2 * t * cPnt1[0]) + (3 * tp * t2 * cPnt2[0]) + (t3 * endPnt[0])
        let y = (tp3 * startPnt[1]) + (3 * tp2 * t * cPnt1[1]) + (3 * tp * t2 * cPnt2[1]) + (t3 * endPnt[1])
        return [x, y]
    }

    isClockWise(pnt1, pnt2, pnt3) {
        return ((pnt3[1] - pnt1[1]) * (pnt2[0] - pnt1[0]) > (pnt2[1] - pnt1[1]) * (pnt3[0] - pnt1[0]))
    }
    getBisectorNormals(t, pnt1, pnt2, pnt3) {
        var that = this;
        let normal = that.getNormal(pnt1, pnt2, pnt3)
        let [bisectorNormalRight, bisectorNormalLeft, dt, x, y] = [null, null, null, null, null]
        let dist = Math.sqrt(normal[0] * normal[0] + normal[1] * normal[1])
        let uX = normal[0] / dist
        let uY = normal[1] / dist
        let d1 = that.distance(pnt1, pnt2)
        let d2 = that.distance(pnt2, pnt3)
        if (dist > ZERO_TOLERANCE) {
            if (that.isClockWise(pnt1, pnt2, pnt3)) {
                dt = t * d1
                x = pnt2[0] - dt * uY
                y = pnt2[1] + dt * uX
                bisectorNormalRight = [x, y]
                dt = t * d2
                x = pnt2[0] + dt * uY
                y = pnt2[1] - dt * uX
                bisectorNormalLeft = [x, y]
            } else {
                dt = t * d1
                x = pnt2[0] + dt * uY
                y = pnt2[1] - dt * uX
                bisectorNormalRight = [x, y]
                dt = t * d2
                x = pnt2[0] - dt * uY
                y = pnt2[1] + dt * uX
                bisectorNormalLeft = [x, y]
            }
        } else {
            x = pnt2[0] + t * (pnt1[0] - pnt2[0])
            y = pnt2[1] + t * (pnt1[1] - pnt2[1])
            bisectorNormalRight = [x, y]
            x = pnt2[0] + t * (pnt3[0] - pnt2[0])
            y = pnt2[1] + t * (pnt3[1] - pnt2[1])
            bisectorNormalLeft = [x, y]
        }
        return [bisectorNormalRight, bisectorNormalLeft]
    }


    getThirdPoint(startPnt, endPnt, angle, distance, clockWise) {
        var that = this;
        let azimuth = that.getAzimuth(startPnt, endPnt)
        let alpha = clockWise ? (azimuth + angle) : (azimuth - angle)
        let dx = distance * Math.cos(alpha)
        let dy = distance * Math.sin(alpha)
        return ([endPnt[0] + dx, endPnt[1] + dy])
    }



}

export default DrawGatheringPlace;